import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AppStateProvider } from './state/app-state';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { SearchStateProvider } from './state/search-sate';

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppStateProvider>
        <QueryClientProvider client={queryClient}>
          <SearchStateProvider>
            <App />
          </SearchStateProvider>
        </QueryClientProvider>
      </AppStateProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// disable default validation popups
document.addEventListener(
  'invalid',
  (
    () =>
    (event): void => {
      event.preventDefault();
    }
  )(),
  true,
);
